import {
    DEPOSITS_LOADING_TOGGLE,
    GET_DEPOSITS_SUCCESS,
    GET_DEPOSITS_FAILED,
    GET_DEPOSIT_BY_ID_SUCCESS,
    GET_DEPOSIT_BY_ID_FAILED,
    CREATE_DEPOSIT_SUCCESS,
    CREATE_DEPOSIT_FAILED,
    UPDATE_DEPOSIT_SUCCESS,
    UPDATE_DEPOSIT_FAILED,
    CLOSE_DEPOSIT_SUCCESS,
    CLOSE_DEPOSIT_FAILED,
    GET_DEPOSIT_HISTORY_SUCCESS,
    GET_DEPOSIT_HISTORY_FAILED,
    GET_DEPOSITS_DROPDOWN_SUCCESS,
    GET_DEPOSITS_DROPDOWN_FAILED,
    GET_DEPOSITOR_DEPOSIT_SUMMARY_SUCCESS,
    GET_DEPOSITOR_DEPOSIT_SUMMARY_FAILED,
    CREATE_DEPOSIT_TRANSACTION_SUCCESS,
    CREATE_DEPOSIT_TRANSACTION_FAILED,
    GET_DEPOSIT_INTEREST_HISTORY_SUCCESS,
    GET_DEPOSIT_INTEREST_HISTORY_FAILED,
    UPDATE_INTEREST_RATE_SUCCESS,
    UPDATE_INTEREST_RATE_FAILED,
    CLEAR_DEPOSIT_ERRORS
} from "../actions/DepositsActions";

const initialState = {
    list: [],
    data: {},
    history: [],
    interestHistory: [],
    dropdown: [],
    summary: {},
    pagination: {
        currentPage: 1,
        totalPages: 1,
        totalRecords: 0,
        recordsPerPage: 10,
        hasNextPage: false,
        hasPreviousPage: false
    },
    loading: false,
    error: null,
    success: null
};

const DepositsReducer = (state = initialState, action) => {
    switch (action.type) {
        case DEPOSITS_LOADING_TOGGLE:
            return { ...state, loading: action.payload };
        case GET_DEPOSITS_SUCCESS:
            return {
                ...state,
                list: action.payload.data || [],
                pagination: action.payload.pagination || initialState.pagination,
                error: null
            };
        case GET_DEPOSITS_FAILED:
            return { ...state, error: action.payload };
        case GET_DEPOSIT_BY_ID_SUCCESS:
            return { ...state, data: action.payload.data, error: null };
        case GET_DEPOSIT_BY_ID_FAILED:
            return { ...state, error: action.payload };
        case CREATE_DEPOSIT_SUCCESS:
            return { ...state, data: action.payload.data, success: action.payload.message, error: null };
        case CREATE_DEPOSIT_FAILED:
            return { ...state, error: action.payload };
        case UPDATE_DEPOSIT_SUCCESS:
            return { ...state, data: action.payload.data, success: action.payload.message, error: null };
        case UPDATE_DEPOSIT_FAILED:
            return { ...state, error: action.payload };
        case CLOSE_DEPOSIT_SUCCESS:
            return { ...state, data: action.payload.data, success: action.payload.message, error: null };
        case CLOSE_DEPOSIT_FAILED:
            return { ...state, error: action.payload };
        case GET_DEPOSIT_HISTORY_SUCCESS:
            return {
                ...state,
                history: action.payload.data || [],
                pagination: action.payload.pagination || initialState.pagination,
                error: null
            };
        case GET_DEPOSIT_HISTORY_FAILED:
            return { ...state, error: action.payload };
        case GET_DEPOSITS_DROPDOWN_SUCCESS:
            return { ...state, dropdown: action.payload.data || [], error: null };
        case GET_DEPOSITS_DROPDOWN_FAILED:
            return { ...state, error: action.payload };
        case GET_DEPOSITOR_DEPOSIT_SUMMARY_SUCCESS:
            return { ...state, summary: action.payload.data || {}, error: null };
        case GET_DEPOSITOR_DEPOSIT_SUMMARY_FAILED:
            return { ...state, error: action.payload };
        case CREATE_DEPOSIT_TRANSACTION_SUCCESS:
            return { 
                ...state, 
                success: "Transaction added successfully", 
                error: null,
                // Optionally update deposit balance if data contains updated deposit info
                ...(action.payload.deposit && { data: { ...state.data, ...action.payload.deposit } })
            };
        case CREATE_DEPOSIT_TRANSACTION_FAILED:
            return { ...state, error: action.payload };
        case GET_DEPOSIT_INTEREST_HISTORY_SUCCESS:
            return {
                ...state,
                interestHistory: action.payload.data || [],
                pagination: action.payload.pagination || initialState.pagination,
                error: null
            };
        case GET_DEPOSIT_INTEREST_HISTORY_FAILED:
            return { ...state, error: action.payload };
        case UPDATE_INTEREST_RATE_SUCCESS:
            return { 
                ...state, 
                success: "Interest rate updated successfully", 
                error: null,
                // Optionally update deposit interest rate if data contains updated deposit info
                ...(action.payload.deposit && { data: { ...state.data, ...action.payload.deposit } })
            };
        case UPDATE_INTEREST_RATE_FAILED:
            return { ...state, error: action.payload };
        case CLEAR_DEPOSIT_ERRORS:
            return { ...state, error: null, success: null };
        default:
            return state;
    }
};

export default DepositsReducer;
